// extracted by mini-css-extract-plugin
export default {"banner":"CookiesBanner_banner__jPwBL"};